var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"block max-w-full max-h-full"},[_c('div',{class:_vm.playerClasses,attrs:{"data-test":"video"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }